import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const StorePickup24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      d="M15.689 13.255l3.526 3.39-1.506.04 1.191 2.946-.927.374L16.757 17l-1.25 1.144.182-4.888zM11.89 3c2.102 0 3.386 1.56 3.922 4.107L21 7.118v7.436a4.88 4.88 0 00-4.125-2.26c-2.692 0-4.875 2.167-4.875 4.84 0 .66.133 1.29.374 1.863H3V7.08l4.973.01C8.51 4.553 9.794 3 11.89 3zM4 8.083v9.914h7.064a5.847 5.847 0 01-.064-.862c0-3.228 2.632-5.84 5.875-5.84 1.131 0 2.208.32 3.125.893V8.116l-4.02-.008c.083.665.124 1.381.124 2.142h-1c0-.777-.045-1.494-.134-2.144l-6.156-.013c-.09.653-.135 1.375-.135 2.157h-1c0-.767.042-1.49.126-2.159L4 8.083zM11.891 4C10.444 4 9.467 5.13 9 7.093l5.787.012C14.32 5.135 13.342 4 11.891 4z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default StorePickup24;
